import { GET, POST } from '../request'
export default {
  /**
   * 招聘分组列表
   */
  getRecruitPage: (data) => {
    return POST('/front/recruit/getRecruitList', data)
  },
  /**
   * 职位列表
   */
  getPositionPage: (data) => {
    return POST('/front/position/getPositionPage', data)
  },
  /**
   * 职位详情
   */
  getPositionById: (data) => {
    return GET('/front/position/getPositionById', data)
  },
  /**
   * 合作伙伴列表
   */
  getCoopPartnerPage: (data) => {
    return POST('/front/coopPartner/getCoopPartnerPage', data)
  },
  /**
   * 商业客户列表
   */
  getCustomePage: (data) => {
    return POST('/front/custome/getCustomePage', data)
  },
  /**
   * 成长伙伴列表
   */
  getGrowthPartnerPage: (data) => {
    return POST('/front/growthPartner/getGrowthPartnerPage', data)
  },
  /**
   * 荣誉奖项列表
   */
  getHonorrPage: (data) => {
    return POST('/front/honor/listHonors', data)
  },
  /**
   * 服务专家列表
   */
  getExpertPage: (data) => {
    return POST('/front/expert/getExpertPage', data)
  },
  /**
   * 文章列表（资讯中心）
   */
  getArticlePage: (data) => {
    return POST('/front/article/getArticlePage', data)
  },
  /**
   * 文章详情（资讯中心）
   */
  getArticleDetail: (data) => {
    return GET('/front/article/getArticleDetail', data)
  },
  /**
   * 商业案例列表
   */
  getCasePage: (data) => {
    return POST('/front/case/getCasePage', data)
  },
  /** 提交资讯信息（核心竞争力） */
  submitCoop: (data) => {
    return POST('/front/coop/submitCoop', data)
  },
  /** 智能硬件 */
  listAllHardware: (data) => {
    return GET('/front/hardware/listAllHardware', data)
  },
  /**
   * 服务与解决方案子模式获取
   */
  listAllmodel: (data) => {
    return GET('/front/modeType/listAllmodel', data)
  },
  /**
   * 农芯介绍列表分页
   */
  getComProfilePage: (data) => {
    return POST('/front/comProfile/getComProfilePage', data)
  }
}
